import DownloadPage from '@/components/Pages/DownloadPage';

export default DownloadPage;
